import { render } from "./Sign.vue?vue&type=template&id=5478cd85&scoped=true&ts=true"
import script from "./Sign.vue?vue&type=script&lang=ts"
export * from "./Sign.vue?vue&type=script&lang=ts"

import "./Sign.vue?vue&type=style&index=0&id=5478cd85&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src754147292/src/web-ext-galaxycorp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5478cd85"]])

export default __exports__